import {createAction} from "@reduxjs/toolkit";

export const createSteps = createAction("@blockchain/steps");
export const successSteps = createAction("@blockchain/successSteps");
export const resetSteps = createAction("@blockchain/resetSteps");

export const nextStep = createAction("@blockchain/nextStep");
export const retryStep = createAction("@blockchain/retryStep");
export const failStep = createAction("@blockchain/failStep");
